import { render } from "./EngineeringDesign.vue?vue&type=template&id=e5ab1c28&scoped=true"
import script from "./EngineeringDesign.vue?vue&type=script&lang=js"
export * from "./EngineeringDesign.vue?vue&type=script&lang=js"

import "./EngineeringDesign.vue?vue&type=style&index=0&id=e5ab1c28&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ab1c28"]])

export default __exports__